import { render, staticRenderFns } from "./qiyeClass.vue?vue&type=template&id=f0ff9a06"
import script from "./qiyeClass.vue?vue&type=script&lang=js"
export * from "./qiyeClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports